var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 50,
    viewBox: "0 0 43 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.1278,
    cy: 30,
    r: 21.1278,
    fill: "#DFEAEE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_220_3228)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.3948 16.7168H27.7803V43.4643H29.3948C32.0588 43.4643 34.2384 41.2847 34.2384 38.6207V21.5604C34.2384 18.8964 32.0588 16.7168 29.3948 16.7168Z",
    fill: "#E0230D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6232 21.5604V38.6207C32.6232 41.2846 30.4436 43.4643 27.7796 43.4643H12.3338C9.66984 43.4643 7.49023 41.2847 7.49023 38.6207V21.5604C7.49023 18.8964 9.66984 16.7168 12.3338 16.7168H27.7796C30.4436 16.7168 32.6232 18.8964 32.6232 21.5604Z",
    fill: "#FF5440"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8643 19.9463C18.3641 19.9463 16.3301 21.9803 16.3301 24.4805V35.7015C16.3301 38.2017 18.3641 40.2357 20.8643 40.2357C23.3644 40.2357 25.3984 38.2017 25.3984 35.7015V24.4805C25.3984 21.9803 23.3644 19.9463 20.8643 19.9463ZM23.2457 35.7015C23.2457 37.0145 22.1774 38.0829 20.8643 38.0829C19.5512 38.0829 18.4828 37.0146 18.4828 35.7015V24.4805C18.4828 23.1674 19.5511 22.099 20.8643 22.099C22.1774 22.099 23.2457 23.1673 23.2457 24.4805V35.7015Z",
    fill: "#00365C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_220_3228"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.7475,
    height: 26.7475,
    fill: "white",
    transform: "translate(7.48926 16.7168)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListIcon4);
export default __webpack_public_path__ + "static/media/list-icon4.2c0ad9244a2449edf18adda91be56b05.svg";
export { ForwardRef as ReactComponent };